import { ChangeLayerFunction } from "../../extensions/layerManagerExtension";
import { useDispatchBaseEvent, useSubscribeToBaseEvent } from "../useDispatchBaseEvent";

export const CHANGE_LAYER_EVENT_NAME = "useChangeLayerEvent";

type ChangeLayerEvent = {
  type: typeof CHANGE_LAYER_EVENT_NAME;
  payload: Parameters<ChangeLayerFunction>[0];
};

export function useDispatchChangeLayerEvent() {
  return useDispatchBaseEvent<ChangeLayerEvent>(CHANGE_LAYER_EVENT_NAME);
}

export function useSubscribeToChangeLayerEvent(handler: (payload: ChangeLayerEvent["payload"]) => void) {
  useSubscribeToBaseEvent<ChangeLayerEvent>(CHANGE_LAYER_EVENT_NAME, handler);
}
